import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan25 = withTableController(({ planing, state }) => (
  <Plan planing={planing} state={state} />
));

export default Plan25;
